import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CatalogService } from 'src/app/services/catalog.service';
import { ContractService } from 'src/app/services/contract.service';
import { ProjectService } from 'src/app/services/project.service';
import { ToastService } from 'src/app/services/toast.service';
import { DimensionInformationEnum, RegisterCatalogEnum, SignalingImageSituationEnum, SignalingTypeEnum, SupportMaterialTypeEnum, TaskTypeEnum, VerticalGroupTypeEnum, VerticalSignalingEnum } from 'src/enumerators';
import { environment } from 'src/environments/environment';
import { Contract, ContractDeviceGroup, ContractDeviceItem, ContractHorizontalGroup, ContractHorizontalItem, ContractVerticalGroup, ContractVerticalItemSupport, Member, Project, VerticalSignaling } from 'src/models';

@Component({
  selector: 'app-display-summary-activitie',
  templateUrl: './display-summary-activitie.component.html',
  styleUrls: ['./display-summary-activitie.component.css']
})
export class DisplaySummaryActivitieComponent implements OnInit, OnChanges {

  @Input() activitie;
  ngIconClass;

  signTypeEnum = SignalingTypeEnum;
  verticalSignEnum = VerticalSignalingEnum;
  imageSituationEnum = SignalingImageSituationEnum;

  selectedSign: any // Sinalização selecionada
  validateLocation: boolean = false;

  storage = []; //Lista de materiais em estoque;

  workspaceMembers: Member[] = []; // lista de membros da workspace

  contractList: Contract[] = []; // Lista de Contratos das sinalizações
  projectList = []; // Lista de Projetos das sinalizações

  selectedContract = new Contract({}); //Contrato da pendência selecionada
  selectedProject = new Project({}); //Projeto da pendência selecionada
  contractRoadItems = []; //Lista de itens do contrato

  projectItemContractSet: Set<string> = new Set(); // Lista com os item do contrato
  roadSignSupportItems = []; //Lista de suportes do contrato
  supportMaterials = Object.values(SupportMaterialTypeEnum);

  substrateList = []; //Lista de Substratos
  filmList = []; //Lista de Películas
  markPaintingList = [] //Lista de Tintas

  attachments: Array<Object> = [];

  registerCatalogEnum = RegisterCatalogEnum; // Enum para usar no HTML

  imageSigns: Array<{
    imagesB64List: any; // image b64, como o tipo File não tem URL, precisa disso
    imagesFileList: any; // imagem tipo File pra mandar pro back
    removeImagesIdList: any; // Imagens removidas, para edição/update
  }> = [];

  constructor(
    private _toastService: ToastService,
    private _contractService: ContractService,
    private _projectService: ProjectService,
    private _catalogService: CatalogService,
  ) {};

  ngOnInit(): void {
    this._contractService.listAllWorkspaceUsers({files: false}).subscribe((next: any) => {
      this.workspaceMembers = next.members;
    });

    this.getContracts();
    this.getProjects();
    this.getMaterials();

    if (this.imageSigns.length == 0) {
      this.imageSigns[0] = {
        imagesB64List: [undefined, undefined, undefined, undefined],
        imagesFileList: [undefined, undefined, undefined, undefined],
        removeImagesIdList: [],
      };
      this.imageSigns[1] = {
        imagesB64List: [undefined, undefined, undefined, undefined],
        imagesFileList: [undefined, undefined, undefined, undefined],
        removeImagesIdList: [],
      };
    };
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (this.activitie) {
      this.ngIconClass = {
        'fa-square-plus': this.activitie['task']?.taskType == TaskTypeEnum.Implantation,
        'fa-square-x': this.activitie['task']?.taskType == TaskTypeEnum.Removal,
        'fa-brush': this.activitie['task']?.taskType == TaskTypeEnum.Maintenance,
        'fa-arrow-down-to-bracket': this.activitie['task']?.taskType == TaskTypeEnum.Cataloging,
        'fa-arrows-cross': this.activitie['task']?.taskType == TaskTypeEnum.Replacement,
      };

      this.selectedSign = undefined;
    }
  }

  getContracts() {
    this._contractService.listFullContracts().subscribe(
      (contracts: Contract[]) => {
        this.contractList = contracts;
      }
    )
  }

  getProjects() {
    this._projectService.getProjects().subscribe(
      (projects: Project[]) => {
        this.projectList = projects;
      }
    )
  }

  getMaterials() {
    this._contractService.populateSubs().subscribe((res) => {
      this.substrateList = res as any;
    });
    this._contractService.populateFilms().subscribe((res) => {
      this.filmList = res as any;
    });
    this._contractService.populateMarkPainting().subscribe((res) => {
      this.markPaintingList = res as any;
    });
  }

  normalizeName(name) {
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  getResponsibleMemberName(responsibleMemberId, workspaceMembers) {
    const member = workspaceMembers.find(m => m.id === responsibleMemberId);
    if (!member || !member.user) return '';

    const firstName = this.normalizeName(member.user.firstName);
    const lastName = this.normalizeName(member.user.lastName);

    return `${firstName} ${lastName}`;
  }

  openTaskPage() {
    const url = `/#/services/task/resume/task-resume/${this.activitie['task']?.id}`;
    window.open(url, '_blank');
  }

  getSignFile(signFiles: any[] = []) {
    if (signFiles?.length) {
      let signImages = signFiles.filter(f => f['situation'] == SignalingImageSituationEnum.Before)
      if (signImages.length) return signImages[0];
      else return signFiles[0];
    } else return null;
  }

  signDetailRouting(sign, activitie) {
    let type;
    let id;
    if (activitie?.type == SignalingTypeEnum.Vertical) {
      type = sign.id;
      id = sign.verticalSignalingId;
    } else {
      type = activitie?.type;
      id = sign.id;
    }
    const url = `/#/catalog/detail/${id}?type=${type}`;
    window.open(url, '_blank');
  }

  populateContractItems() {
    this.contractRoadItems = [];
    this.roadSignSupportItems = [];
    switch (this.selectedSign.type) {
      case SignalingTypeEnum.Vertical:
        for (const group of this.selectedContract?.verticalGroups as ContractVerticalGroup[]) {
          for (const item of group?.verticalItems) {
            if (group.groupType === VerticalGroupTypeEnum.RoadSign) {
              this.contractRoadItems.push(item);
            } else {
              this.roadSignSupportItems.push(item);
            }
          }
        }
        break;

      case SignalingTypeEnum.Horizontal:
        for (const group of this.selectedContract?.horizontalGroups as ContractHorizontalGroup[]) {
          for (const item of group?.horizontalItems as ContractHorizontalItem[]) {
            this.contractRoadItems.push(item);
          }
        }
        break;

      case SignalingTypeEnum.Device:
        for (const group of this.selectedContract?.deviceGroups as ContractDeviceGroup[]) {
          for (const item of group?.deviceItems) {
            this.contractRoadItems.push(item);
          }
        }
        break;

      default:
        break;
    }
  }

  getPendencyContractAndProject() {
    this.selectedContract = this.contractList.find(contract => contract.id == this.selectedSign.contractId);
    this.selectedProject = this.projectList.find(project => project.id == this.selectedSign.projectId);

    if (this.selectedContract) this.populateContractItems();
  }

  selectSignaling(sign: any) {
    this.selectedSign = sign;

    if (sign.type === SignalingTypeEnum.Horizontal) this.attachments = sign.horizontalSignalingFiles;

    if (sign.type === SignalingTypeEnum.Vertical) {
      this.attachments = sign.verticalSignaling?.verticalSignalingFiles;
    };

    if (sign.type === SignalingTypeEnum.Device) this.attachments = sign.deviceSignalingFiles;

    this.fillImagesList();

    if (this.selectedSign.warranty) {
      this.selectedSign.warranty = new Date(this.selectedSign.warranty);
    }

    if (this.selectedSign?.contractId) {
      this.getPendencyContractAndProject();
    }
  }

  cancelSignUpdate() {
    this.selectedSign = undefined;
  }

  validateSignaling() {
    if (
      !this.selectedSign.warranty ||
      !this.selectedSign.dimension ||
      (this.selectedSign.contract?.id && !this.selectedSign.contractSignItemId) ||
      (
        this.selectedSign.type == SignalingTypeEnum.Vertical &&
        !this.selectedSign.contract?.id &&
        (!this.selectedSign.roadSignFilmId || !this.selectedSign.roadSignSubstrateId)
      ) ||
      (
        this.selectedSign.type == SignalingTypeEnum.Horizontal &&
        !this.selectedSign.contract?.id &&
        !this.selectedSign.roadSignMarkingPaintId
      ) ||
      !this.validateLocation
    ) {
      return true
    }
    return false
  }

  imageExists() {
    if (this.selectedSign.type == SignalingTypeEnum.Vertical) {
      return this.selectedSign.verticalSignalingFiles.length > 0;
    } else if (this.selectedSign.type == SignalingTypeEnum.Horizontal) {
      return this.selectedSign.horizontalSignalingFiles.length > 0;
    } else {
      return this.selectedSign.deviceSignalingFiles.length > 0;
    }
  }

  getImageList() {
    if (this.selectedSign.type == SignalingTypeEnum.Vertical) {
      return this.selectedSign.verticalSignalingFiles;
    } else if (this.selectedSign.type == SignalingTypeEnum.Horizontal) {
      return this.selectedSign.horizontalSignalingFiles;
    } else {
      return this.selectedSign.deviceSignalingFiles;
    }
  }

  downloadFileSign(fileUrl: string) {
    window.open(fileUrl, 'Download');
  }

  getImageEmpty(situation: SignalingImageSituationEnum): boolean {
    let situationEmpty = true;
    this.getImageList().some(file => {
      if (file.situation == situation) {
        situationEmpty = false;
        return true
      }
    });
    return situationEmpty;
  }

  onChangeSupportItem(value, isStock?, stockedSupportId?: string) {
    let supportItems = isStock
      ? this.roadSignSupportItems.map((v) => v.contractVerticalItem)
      : [...this.roadSignSupportItems];
    if (this.selectedContract) {
      supportItems.forEach((support) => {
        if (support.id == value) {
          if (this.selectedContract) {
            this.selectedSign.contractSupportItem = new ContractVerticalItemSupport(support);
            this.selectedSign.supportMaterialType = support.supportMaterial;
          }
        }
      });
    }
    if (isStock) {
      this.selectedSign.stockedSupportId = stockedSupportId;
      this.selectedSign.contractSupportItemId = value;
    }
  }

  onChangeSupportQuantity() {
    if (this.selectedSign.supportQuantity < 1) {
      this.selectedSign.supportQuantity = 1;
    }
  }

  fillImagesList() {
    this.imageSigns[0] = {
      imagesB64List: [undefined, undefined, undefined, undefined],
      imagesFileList: [undefined, undefined, undefined, undefined],
      removeImagesIdList: [],
    };

    this.imageSigns[1] = {
      imagesB64List: [undefined, undefined, undefined, undefined],
      imagesFileList: [undefined, undefined, undefined, undefined],
      removeImagesIdList: [],
    };

    this.attachments.forEach((file) => {
      if (file['situation'] == SignalingImageSituationEnum.After) {
        this.imageSigns[0].imagesB64List.some((img, index) => {
          if (!img) {
            this.imageSigns[0].imagesB64List[index] = file;
            return true;
          }
        });
      } else {
        this.imageSigns[1].imagesB64List.some((img, index) => {
          if (!img) {
            this.imageSigns[1].imagesB64List[index] = file;
            return true;
          }
        });
      }
    });


    console.log({ images: this.imageSigns });
  };

  // Atribui valor do componente de dimensão para a sinalização
  handleDimensionInformation(
    event: {
      dimensionType: DimensionInformationEnum;
      dimension: number;
      dimensionX: number;
      dimensionY: number;
      units: number;
      diameter: number;
      sideLength: number;
      quantity: number;
      dash: number;
      spacing: number;
    }
  ) {
    if (this.selectedSign.type == SignalingTypeEnum.Vertical) {
      this.selectedSign.diameter = event.diameter;
      this.selectedSign.dimension = event.dimension;
      this.selectedSign.dimensionX = event.dimensionX;
      this.selectedSign.dimensionY = event.dimensionY;
      this.selectedSign.sideLength = event.sideLength;
      this.selectedSign.dimensionType = event.dimensionType;
    } else if (this.selectedSign.type == SignalingTypeEnum.Horizontal) {
      this.selectedSign.quantity = event.quantity;
      this.selectedSign.dimension = event.dimension;
      this.selectedSign.dimensionX = event.dimensionX;
      this.selectedSign.dimensionY = event.dimensionY;
      this.selectedSign.dimensionType = event.dimensionType;
      this.selectedSign.dash = event.dash;
      this.selectedSign.spacing = event.spacing;
    } else {
      this.selectedSign.units = event.units;
      this.selectedSign.dimension = event.dimension;
    }
  }

  updateSign() {
    if (this.selectedSign.type == SignalingTypeEnum.Horizontal) this.updateHorizontalSign()
    else if (this.selectedSign.type == SignalingTypeEnum.Device) this.updateDeviceSign()
    else {
      this.setVerticalSignForUpdate()
    }

    this.selectedSign = undefined;

    this._toastService.showSuccess('Sinalização editada com sucesso!');
  }

  updateHorizontalSign() {
    this.selectedSign.contractSignItem = new ContractHorizontalItem(this.selectedSign.contractSignItem);

    // //Aplicando localização dos pontos editados
    // this.pointsNearPath.forEach((point, index) => {
    //   this.selectedPendency.locations[index] = new Location(point);
    // })

    //Atualizando Sinalização e alterando status da pendência
    this._catalogService.putHorizontalSign(this.selectedSign.id, this.selectedSign).subscribe(
      next => {

      },
      error => this.showErrorUpdateSign()
    )
  }

  updateDeviceSign() {
    this.selectedSign.contractSignItem = new ContractDeviceItem(this.selectedSign.contractSignItem);

    //Aplicando localização dos pontos editados
    // this.pointsNearPath.forEach((point, index) => {
    //   this.selectedPendency.locations[index] = new Location(point);
    // })

    //Atualizando Sinalização e alterando status da pendência
    this._catalogService.putDeviceSign(this.selectedSign.id, this.selectedSign).subscribe(
      next => {

      },
      error => this.showErrorUpdateSign()
    )
  }

  setVerticalSignForUpdate() {
    this.selectedSign.contractSignItem = new ContractDeviceItem(this.selectedSign.contractSignItem);

    //Aplicando localização dos pontos editados
    // this.selectedSign.lat = this.pointsNearPath[0].lat;
    // this.selectedSign.lng = this.pointsNearPath[0].lng;
    // this.selectedSign.distance = this.pointsNearPath[0].distance;
    // this.selectedSign.endsAt = this.pointsNearPath[0].distance;
    // this.selectedSign.startsAt = this.pointsNearPath[0].marker;

    // let originalSign = this.verticalOriginalSigns.find(sign => sign.id == this.selectedPendency.groupId);

    // //Alterando atritubos da VerticalSignaling (referência)
    // originalSign.lat = this.pointsNearPath[0].lat;
    // originalSign.lng = this.pointsNearPath[0].lng;
    // originalSign.distance = this.pointsNearPath[0].distance;
    // originalSign.endsAt = this.pointsNearPath[0].distance;
    // originalSign.startsAt = this.pointsNearPath[0].marker;

    const selectedTrafficSign = this.selectedSign;

    this._catalogService.getVertical(this.selectedSign.verticalSignalingId).subscribe(
      (verticalSignaling: VerticalSignaling) => {
        const trafficSigns = verticalSignaling?.trafficSigns ?? [];

        const trafficSignIndex = trafficSigns.findIndex(trafficSign => trafficSign.id == selectedTrafficSign.id);

        verticalSignaling.trafficSigns[trafficSignIndex].contractSignItemId = this.selectedSign.contractSignItemId;
        verticalSignaling.trafficSigns[trafficSignIndex].warranty = this.selectedSign.warranty;
        verticalSignaling.trafficSigns[trafficSignIndex].roadSignSubstrateId = this.selectedSign.roadSignSubstrateId;
        verticalSignaling.trafficSigns[trafficSignIndex].roadSignFilmId = this.selectedSign.roadSignFilmId;
        verticalSignaling.trafficSigns[trafficSignIndex].diameter = this.selectedSign.diameter;
        verticalSignaling.trafficSigns[trafficSignIndex].dimension = this.selectedSign.dimension;
        verticalSignaling.trafficSigns[trafficSignIndex].dimensionX = this.selectedSign.dimensionX;
        verticalSignaling.trafficSigns[trafficSignIndex].dimensionY = this.selectedSign.dimensionY;
        verticalSignaling.trafficSigns[trafficSignIndex].dimensionType = this.selectedSign.dimensionType;
        verticalSignaling.trafficSigns[trafficSignIndex].sideLength = this.selectedSign.sideLength;
        verticalSignaling.trafficSigns[trafficSignIndex].stockedTrafficSignId = this.selectedSign.stockedTrafficSignId;

        this.updateVerticalSign(verticalSignaling);
      },
      error => this.showErrorUpdateSign()
    )

    // originalSign.address = this.selectedSign.address;
    // originalSign.direction = this.selectedSign.direction;
    // originalSign.contractSupportItemId = this.selectedSign.contractSupportItemId;
    // originalSign.existingSupport = this.selectedSign.existingSupport;

    // const trafficSignIndex = originalSign.trafficSigns.findIndex(trafficSign => trafficSign.id == this.selectedPendency.id);

    //Alterando atritubos da TrafficSignal (referência)
    // originalSign.trafficSigns[trafficSignIndex].contractSignItemId = this.selectedPendency.contractSignItemId;
    // originalSign.trafficSigns[trafficSignIndex].lat = this.pointsNearPath[0].lat;
    // originalSign.trafficSigns[trafficSignIndex].lng = this.pointsNearPath[0].lng;
    // originalSign.trafficSigns[trafficSignIndex].warranty = this.selectedPendency.warranty;
    // originalSign.trafficSigns[trafficSignIndex].roadSignSubstrateId = this.selectedPendency.roadSignSubstrateId;
    // originalSign.trafficSigns[trafficSignIndex].roadSignFilmId = this.selectedPendency.roadSignFilmId;
    // originalSign.trafficSigns[trafficSignIndex].diameter = this.selectedPendency.diameter;
    // originalSign.trafficSigns[trafficSignIndex].dimension = this.selectedPendency.dimension;
    // originalSign.trafficSigns[trafficSignIndex].dimensionX = this.selectedPendency.dimensionX;
    // originalSign.trafficSigns[trafficSignIndex].dimensionY = this.selectedPendency.dimensionY;
    // originalSign.trafficSigns[trafficSignIndex].dimensionType = this.selectedPendency.dimensionType;
    // originalSign.trafficSigns[trafficSignIndex].sideLength = this.selectedPendency.sideLength;
    // originalSign.trafficSigns[trafficSignIndex].stockedTrafficSignId = this.selectedPendency.stockedTrafficSignId;

    // this.updateVerticalSign(originalSign);
  }

  updateVerticalSign(obj: VerticalSignaling) {
    this._catalogService.putVerticalSign(obj.id, obj).subscribe(
      next => {
        this.selectedSign = undefined;
      },
      error => this.showErrorUpdateSign()
    )
  }

  showErrorUpdateSign() {
    this._toastService.showError('Houve um erro ao atualizar os dados da Sinalização.');
  }

  private allowedWorkspaceIdsAuxiliarGroups: string[] = [
    'f35489a0-83bf-11ee-9246-d35f7bdbc3f2',
  ];

  shouldDisplayAuxiliarGroup(): boolean {
    const environmentEndpoint = environment.endpoint();

    return (
      this.allowedWorkspaceIdsAuxiliarGroups.includes(this.selectedSign.workspaceId) || !environment.production || environmentEndpoint.includes('hellius.dev.')
    );
  };

}
